export default __webpack_public_path__ + "static/media/CashRegister.00ebc49a.png";